<div class="view-container">
  <div class="header-section" id="header" tabindex="0">
    @if (!loader.isLoading && currentUser) {
      <div class="header-title">
        {{currentUser.name}} : &nbsp;
        @if (currentUser.isSuperAdmin) {
          <strong class="mat-elevation-z1">Super Admin</strong>
        }
        @else {
          <strong class="mat-elevation-z1">{{currentUser.roleName}}</strong>
        }
      </div>
    }
    <div class="cancel-icon">
      <mat-icon [autofocus]="true" class="cross-icon" title="Close" (click)="cancel()">cancel</mat-icon>
    </div>
  </div>
  @if (loader.isLoading) {
    <div class="loader-class loader-position">
      <mat-spinner color="primary"></mat-spinner>
      <div class="loader-message">{{loader.message}}</div>
    </div>
  }
  @if (errorMessage) {
    <div class="error-container">
      <div class="div-error-icon"><mat-icon>error_outline</mat-icon></div>
      <div class="loader-message">{{errorMessage}}</div>
    </div>
  }
  @if (!loader.isLoading && !errorMessage) {
    <div class="role-order">Order of Role Level Precedence :
      <strong>Super Admin > Company Admin > Shop Admin > User</strong>
    </div>
    <div class="role-display" [class.centered]="currentUser.isSuperAdmin">
      <div class="role-description"><em>Role Description</em> : {{currentUserRole.roleDescription}}</div>
      @if (!currentUser.isSuperAdmin && currentUser.accessList.length !== 0) {
        <div class="roles-table">
          <app-table-template [tableData]="currentUseraccessList" [columnList]="columnList"
            [isBoxedTable]="true" [showCaptionPanel]="false" [loading]="loader.isLoading"
            [showFilters]="false" [sortableTable]="false" [isPaginationEnabled]="false">
          </app-table-template>
        </div>
      }
    </div>
  }
</div>